import React, { useState } from 'react';
import * as styles from './DropZone.css.ts';
import { DropZone as DropZoneType } from '../../../types';

interface DropZoneProps {
  zone: DropZoneType;
  isActive: boolean;
  onDrop: (zoneId: string) => void;
  onDragOver?: (zoneId: string) => void;
  onDragLeave?: () => void;
  debug?: boolean;
}

export const DropZone: React.FC<DropZoneProps> = ({
  zone,
  isActive,
  onDrop,
  onDragOver,
  onDragLeave,
  debug = false
}) => {
  const [isDragOver, setIsDragOver] = useState(false);


  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isDragOver) {
      setIsDragOver(true);
      onDragOver?.(zone.id);
    }
  };

  const handleDragLeave = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    // 要素の境界を完全に離れた場合のみリセット
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX;
    const y = e.clientY;
    
    if (x < rect.left || x > rect.right || y < rect.top || y > rect.bottom) {
      setIsDragOver(false);
      onDragLeave?.();
    }
  };

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragOver(false);
    onDrop(zone.id);
  };

  // ドロップゾーンタイプに応じたクラス名を決定
  const getTypeClass = () => {
    if (zone.type === 'merge') return styles.merge;
    if (zone.type.startsWith('split-')) return styles.split;
    return '';
  };

  const className = [
    styles.dropZone,
    getTypeClass(),
    isActive ? styles.active : '',
    isDragOver ? styles.dragOver : '',
    debug ? styles.debug : ''
  ].filter(Boolean).join(' ');

  const style: React.CSSProperties = {
    left: zone.bounds.x,
    top: zone.bounds.y,
    width: zone.bounds.width,
    height: zone.bounds.height,
    display: isActive ? 'block' : 'none'
  };

  return (
    <div
      className={className}
      style={style}
      data-zone-id={zone.id}
      data-zone-type={zone.type}
      data-testid={`drop-zone-${zone.type}`}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    />
  );
};
